import {type FunctionalComponent, h} from '@stencil/core';
import type {InternalAddressesStrategyService} from '../../../../../../strategies/InternalAddressesStrategyService';
import {INTERNAL_ADDRESSES} from '../../../../../../strategies/utils/variables';
import type {Strategies} from '../../../../../../strategies/Strategies';
import {Availibility, Categories} from '../../types/newProductCard.type';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';

export interface ProductCardSidePanelEshopSection {
  eShop: boolean;
  btnUrl: string;
  gridView: boolean;
  labelProvider: labelProviderInterface;
  availibility: boolean;
  category: string;
  strategies?: Strategies;
  size?: string;
  eShopsClickHandler?: Function;
}

export const ProductCardSidePanelEshopSection: FunctionalComponent<
  ProductCardSidePanelEshopSection
> = (props) => {
    const isSectionVisible =
    props.eShop &&
    props.category === Categories.PRODUCT &&
    props.btnUrl &&
    props.availibility;

    return isSectionVisible && (
      <div class="product-card-eshop-section" >
        <qds-button
          data-card-area={'eshop_link'}
          importance="standard"
          size={props.size || 'standard'}
          text={props.labelProvider('result.product.view-on-eshop', 'View On Eshop')}
          href={props.btnUrl}
          target='_blank'
          onClick={(e) => props.eShopsClickHandler ? props.eShopsClickHandler(e) : void 0}
          class={{'product-card-eshop__link--grid': props.gridView, 'product-card-eshop-btn': true}}>
        </qds-button>
      </div>
    );
};
